export default __webpack_public_path__ + "static/media/empty-avatar.50448e5a.svg";